<template>
  <div class="community-container">
    <b-container>
      <MeetSection />
      <DiscordSection />
      <SocialSection />
    </b-container>
  </div>
</template>

<script>
import DiscordSection from "@/components/community/DiscordSection";
import MeetSection from "@/components/community/MeetSection";
import SocialSection from "@/components/community/SocialSection";

export default {
  mounted() {
    window.analytics.page("Community");
  },

  components: {
    DiscordSection,
    MeetSection,
    SocialSection
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.section {
  padding-bottom: 150px;
}
.community-container {
  overflow: hidden;
}

// Other
// ------------------------------
.navbar-container {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Community.vue